import { Stack } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ScreenAnalytics from 'shared/components/ScreenAnalytics/ScreenAnalytics';
import { SMALL_SCREEN_MAX_WIDTH } from 'shared/constants/layout';
import theme from 'shared/styles/theme';

function PublicLayoutWeb() {
  return (
    <View style={styles.container}>
      <ScreenAnalytics />
      <Stack
        screenOptions={{
          contentStyle: {
            backgroundColor: theme.color.background.primary,
          },
          headerShown: false,
        }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    marginHorizontal: 'auto',
    maxWidth: SMALL_SCREEN_MAX_WIDTH,
    width: '100%',
  },
});

export default PublicLayoutWeb;
